import {Component, EventEmitter, Input, Output} from '@angular/core';
import {VehicleBrand} from 'src/app/domain/core/vehicle-brand.model';
import {CommonModule} from '@angular/common';
import {Dealer} from '../../../../domain/data/customer-client-response.data';
import {CustomerClientRequest} from '../../../../domain/data/customer-client-request.data';

@Component({
    selector: 'app-preferred-dealer',
    templateUrl: './preferred-dealer.component.html',
    imports: [CommonModule]
})
export class PreferredDealerComponent {
  @Input() customerConsentRequest: CustomerClientRequest;
  @Input() editPreferredDealerMode = false;
  @Input() editPreferredDealerLexusMode = false;
  @Input() toyota = false;
  @Input() lexus = false;
  @Input() preferredDealer: Dealer
  @Input() preferredDealerLexus: Dealer
  @Input() brand: VehicleBrand

  @Output() onEditPreferredDealer = new EventEmitter<void>();
  @Output() offEditPreferredDealer = new EventEmitter<void>();
  @Output() onEditPreferredDealerLexus = new EventEmitter<void>();
  @Output() offEditPreferredDealerLexus = new EventEmitter<void>();

  handleEditToyota() {
    if (this.editPreferredDealerMode) {
      this.offEditPreferredDealer.emit();
    } else {
      this.onEditPreferredDealer.emit();
    }
  }

  handleEditLexus() {
    if (this.editPreferredDealerLexusMode) {
      this.offEditPreferredDealerLexus.emit();
    } else {
      this.onEditPreferredDealerLexus.emit();
    }
  }
}
